import { useResource } from '@lp/features/RoutePlanner/hooks/useResource';
import { useGoTimeState } from '@lp/features/CaseOverview/components/Tabs/AssignedResources/components/AssignResourcesModal/hooks';
import { RouteResourceCard } from './RouteResourceCard';
import { CaseFacility, CaseResourceType } from '@/api/apis/case';
import { useCaseDetails } from '@/hooks/useCaseDetails';
import { getTimeZonedDate } from '@/utils/helpers';

type ClinicalSpecialistCardProps = {
  id?: string;
  donorHospital?: CaseFacility;
  disabled?: boolean;
};

export const ClinicalSpecialistCard = ({ id = '', donorHospital, disabled }: ClinicalSpecialistCardProps) => {
  const { donorHospitalDate, donorHospitalTime, donorHospitalTimeZone } = useCaseDetails();
  const orCaseDateTime = getTimeZonedDate(donorHospitalDate, donorHospitalTime, donorHospitalTimeZone);
  const { applyGoTime } = useGoTimeState(orCaseDateTime);
  const { resource, resourceData, handleAssignModal, handleViewResourceModal } = useResource({
    type: CaseResourceType.ClinicalSpecialist,
    id,
    donorHospital,
    applyGoTime,
  });

  return (
    <div className="w-48 shrink-0">
      <RouteResourceCard
        hasResource={!!resource}
        imageUrl={resourceData.imageUrl}
        title={resourceData.title}
        statusType={resourceData.statusType}
        subTitle={resourceData.subTitle}
        statusText={resourceData.statusText}
        status={resource?.logisticsStatus}
        showAssignButton={resourceData.showAssignButton}
        onOpen={handleAssignModal}
        onClick={disabled ? () => null : handleViewResourceModal}
      />
    </div>
  );
};
